"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcArrowDirection = void 0;
const components_1 = require("@veeam/components");
const calcArrowDirection = (direction) => {
    switch (direction) {
        case components_1.ARROW_DIRECTION.right:
            return 'rotate(90deg)';
        case components_1.ARROW_DIRECTION.down:
            return 'rotate(180deg)';
        case components_1.ARROW_DIRECTION.left:
            return 'rotate(270deg)';
        case components_1.ARROW_DIRECTION.up:
        default:
            return 'rotate(0)';
    }
};
exports.calcArrowDirection = calcArrowDirection;
//# sourceMappingURL=calcArrowDirection.js.map